export const PROXY_CHILD_ENV_VAR = '__VARLOCK_PROXY_CHILD';
export const PROXY_SESSION_ID_ENV_VAR = '__VARLOCK_PROXY_SESSION_ID';
export const PROXY_SESSION_UUID_ENV_VAR = '__VARLOCK_PROXY_SESSION_UUID';
export const PROXY_PARENT_PID_ENV_VAR = '__VARLOCK_PROXY_PARENT_PID';
export const PROXY_SCHEMA_FINGERPRINT_ENV_VAR = '__VARLOCK_PROXY_SCHEMA_FINGERPRINT';
